import { useCallback } from "react";
import { ParamTypes } from "../constans/paramTypes";
import animalsDB from "../database/animalsDB";
import { formatAnimalName } from "../utils/AnimalsUtils";

export default function useSQLTableSortFormatter() {

    const animalFormatter = useCallback((value) => {
        const animal = animalsDB.getAnimalById(value, { joinEvents: false, findDeleted: true });
        if (!animal) return null;
        return formatAnimalName(animal);
    }, []);

    return useCallback((type) => {
        switch (type) {
            case ParamTypes.ANIMAL: return animalFormatter;
            default: return null;
        }
    }, [animalFormatter]);
}